const initialState = {
    predicitons: [],
};

const lottoReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_PREDICTIONS':
            return {...state, prediciton: action.payload}
        default:
            return state;
    }
};

export default lottoReducer;